{
  "bookmarkTitleLabel": "ブックマーク",
  "debug": "デバッグ",
  "devConnectionLabel": "Developer Connection",
  "exlSection": "Experience League からの結果",
  "feedback": "フィードバック",
  "fetchFailed": "取得できませんでした",
  "help": "ヘルプ",
  "helpDefaultFeatured": "Adobe Experience Cloud のラーニングとサポート",
  "helpLoadError": "エラーが発生しました。もう一度試してください。",
  "noBookmarks": "ブックマークを使用すればここからコンテンツにアクセスできます",
  "noBookmarksTitle": "ブックマークなし",
  "noResults": "結果が見つかりません",
  "noResultsMessage": "スペルを確認するか、別の検索語句を試してください",
  "resourcesCustomerCareLabel": "カスタマーケア",
  "resourcesStatusLabel": "ステータス",
  "support": "サポート"
}
